const phoneNumber = '+1-828-229-7326';
const email = 'support@Cheapgoogleflights.com';
const companyName = 'Cheapgoogleflights';
const companyAddress = `Cheapgoogleflights LLC, 30 N. Gould St Ste 4000, Sheridan, WY 82801`;

const adminpanelurl = 'adminCheapgoogleflights'; // login url of backend
const adminpanelhome= 'admin'; //// home backend url

///// backend url

const urlbc = 'https://aquamarine-squid-721500.hostingersite.com'; 
// // local work
// const urlbc = 'http://localhost:8000';

// const urlbc = 'https://backend-one-beta-78.vercel.app'; 



// const mainColor = '#048c9b';

export { phoneNumber, email, companyName, companyAddress, adminpanelurl, adminpanelhome, urlbc };
